export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Renvoyer le lien du mandat"])},
        "alert": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Le lien sera renvoyé à la même adresse : ", _interpolate(_named("email")), ". Pour l'envoyer à une autre adresse, annulez la demande puis créez-en une nouvelle."])},
        "close_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fermer"])},
        "confirm_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envoyer"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resend the mandate link"])},
        "alert": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["The link will be sent again to the same address: ", _interpolate(_named("email")), ". To send it to another address, cancel the request and create a new one."])},
        "close_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Close"])},
        "confirm_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send"])}
      }
    }
  })
}
